import CustomButton from 'Components/CustomButton'
import CustomDialog from 'Components/CustomDialog/CustomDialog'
import { LinearProgress } from '@mui/material'
import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import type { FC } from 'react'
import { t } from 'ttag'

const WalletTransactionRefundDialog: FC<{
  open: boolean
  handleClose: () => void
  handleSubmit: () => void
  loading: boolean
}> = ({ open, handleClose, handleSubmit, loading }) => {
  const theme = useTheme()

  return (
    <CustomDialog open={open} handleClose={handleClose}>
      <DialogTitle id="dialog-title">{t`Refund wallet transaction`}</DialogTitle>
      <DialogContent>
        {loading ? (
          <LinearProgress />
        ) : (
          <DialogContentText>
            <Typography component="span" color="text.primary">
              {t`Are you sure you want to refund the wallet transaction?`}
            </Typography>
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          sx={{ color: theme.palette.text.primary }}
          onClick={handleClose}
        >{t`Cancel`}</Button>
        <CustomButton onClick={handleSubmit} disabled={loading} autoFocus>
          {t`Refund`}
        </CustomButton>
      </DialogActions>
    </CustomDialog>
  )
}

export { WalletTransactionRefundDialog }
